import React from 'react'


type NotificationContextValue = {
  close: () => void
}

const NotificationContext = React.createContext<NotificationContextValue>(null)


export default NotificationContext
